exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-list li span {\n    width: 24px;\n    height: 24px;\n    padding: 1px;\n    border-radius: 50%;\n    vertical-align: top;\n    cursor: pointer;\n}\nspan {\n    display: inline-block;\n    color: inherit;\n    text-decoration: none;\n    background-color: transparent;\n    outline: 0 !important;\n}\n\n\n", ""]);

// exports
